var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artist) {
if ( artist)
{
buf.push("<p class=\"empty-artist\">Nothing here yet.</p>");
}
else
{
buf.push("<p class=\"empty-recently-added\">Get started by following artists</p>");
}}.call(this,"artist" in locals_for_with?locals_for_with.artist:typeof artist!=="undefined"?artist:undefined));;return buf.join("");
};
module.exports = template;